import { render, staticRenderFns } from "./free-coupons.vue?vue&type=template&id=05952a3e&scoped=true&lang=pug&"
import script from "./free-coupons.vue?vue&type=script&lang=js&"
export * from "./free-coupons.vue?vue&type=script&lang=js&"
import style0 from "./free-coupons.vue?vue&type=style&index=0&id=05952a3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05952a3e",
  null
  
)

export default component.exports